import {useContext} from 'react';

import {useStoreQuery} from '#apollo/schema';
import {Text} from '#component/base';
import {UserStateContext} from '#component/provider';

import {AdditionalProductsRow} from './AdditionalProductsRow/AdditionalProductsRow';

import * as css from './AdditionalProducts.css';

const AdditionalProducts = () => {
  const {data: dataStore, loading} = useStoreQuery();
  const {authenticatedUser} = useContext(UserStateContext);
  const hasMembership = authenticatedUser?.subscription?.hasMembership;
  const {productVariants} = dataStore?.store || {};

  const singleTestKitVariant = productVariants?.filter(
    tk => tk.tid.toLowerCase() === 'pv-tk-oneoff',
  )[0];

  const singleMemberTestKitVariant = productVariants?.filter(
    tk => tk.tid.toLowerCase() === 'pv-tk-oneoff-mem',
  )[0];

  if (loading || !singleTestKitVariant || !singleMemberTestKitVariant) {
    return null;
  } else {
    const price = singleTestKitVariant.price;
    const priceWithDiscount = singleMemberTestKitVariant.price;
    const variantId = hasMembership
      ? parseInt(singleMemberTestKitVariant.id)
      : parseInt(singleTestKitVariant.id);

    return (
      <div>
        <Text
          as="h1"
          variant="heading3"
          color="burgundy"
          className={css.additionalProductsHeadingText}>
          Additional Products{' '}
        </Text>
        <div>
          <AdditionalProductsRow
            image={singleTestKitVariant?.product?.thumbnail || ''}
            isDiscounted={!!hasMembership}
            title={'Individual Test Kit'}
            value={price}
            valueWithDiscount={priceWithDiscount}
            id={variantId}
            variantId={String(variantId)}
          />
        </div>
      </div>
    );
  }
};

export default AdditionalProducts;
